import { render, staticRenderFns } from "./head-nav.vue?vue&type=template&id=ec479c2a&scoped=true&"
import script from "./head-nav.vue?vue&type=script&lang=js&"
export * from "./head-nav.vue?vue&type=script&lang=js&"
import style0 from "./head-nav.vue?vue&type=style&index=0&id=ec479c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec479c2a",
  null
  
)

export default component.exports